import type {Recipe} from './types';

export const patateAlFornoPerfette: Recipe = {
    id: 24,
    key: "patateAlFornoPerfette",
    pictures: [
        {index: 0, url: "https://www.giallozafferano.it/images/242-24202/Patate-al-forno_450x300.jpg"},
    ],
    i18n: {
        IT: {
            title: "Patate al forno perfette",
            servings: "2 persone",
            ingredients: [
                "Patate",
                "Olio di semi di arachidi",
                "Sale",
                "Rosmarino",
            ],
            steps: [
                "Pelare le patate (la dimensione e l'età non sono importanti).  ",
                "Metterle in una pentola e risciacquarle più volte fino a quando l'acqua è limpida.  ",
                "Tagliare le patate in piccoli cubetti con un coltello.  ",
                "Risciacquare nuovamente le patate.  ",
                "Coprire le patate con acqua fredda e aggiungere un cucchiaio di sale, quindi rimescolare.  ",
                "Aspettare 20 minuti o più.  ",
                "Scolare le patate con uno scolapasta (non c'è bisogno di asciugarle).  ",
                "Metterle su carta da forno in una teglia con olio di semi di arachidi, assicurandosi che sia la carta che le patate siano unte.  ",
                "Condire con sale e rosmarino. \n \nMettere in forno preriscaldato ventilato a 200°C fino a doratura.",
            ],
            notes: "Aprire e chiudere velocemente la porta del forno di tanto in tanto per far uscire il vapore che si accumula all'interno (le patate devono seccarsi il più possibile).",
        },
        EN: {
            title: "Perfect Oven Potatoes",
            servings: "2 people",
            ingredients: [
                "Potatoes",
                "Peanut oil",
                "Salt",
                "Rosemary",
            ],
            steps: [
                "Peel the potatoes (size and age don't matter).  ",
                "Place them in a pot and rinse them several times until the water is clear.  ",
                "Cut the potatoes into small cubes with a knife.  ",
                "Rinse the potatoes again.  ",
                "Cover the potatoes with cold water and add a tablespoon of salt, then stir.  ",
                "Let sit for 20 minutes or more.  ",
                "Drain the potatoes with a colander (no need to dry them).  ",
                "Place them on parchment paper in a baking tray with peanut oil, making sure both the paper and potatoes are greased.  ",
                "Season with salt and rosemary.  ",
                "Place in a preheated ventilated oven at 200°C until golden.",
            ],
            notes: "Open and close the oven door quickly from time to time to let the steam out (the potatoes should dry out as much as possible).",
        },
        PL: {
            title: "Idealne pieczone ziemniaki",
            servings: "2 soby",
            ingredients: [
                "Ziemniaki",
                "Olej arachidowy",
                "Sol",
                "Rozmaryn",
            ],
            steps: [
                "Obierz ziemniaki (wielkość i wiek nie mają znaczenia).  ",
                "Włóż je do garnka i opłucz kilkakrotnie, aż woda będzie czysta.  ",
                "Pokrój ziemniaki na małe kostki nożem.  ",
                "Opłucz ziemniaki ponownie.  ",
                "Zalej ziemniaki zimną wodą i dodaj łyżkę soli, a następnie wymieszaj.  ",
                "Odstaw na 20 minut lub dłużej.  ",
                "Odcedź ziemniaki za pomocą durszlaka (nie trzeba ich suszyć).  ",
                "Umieść je na papierze do pieczenia w blasze z olejem arachidowym, upewniając się, że zarówno papier, jak i ziemniaki są natłuszczone.  ",
                "Dopraw solą i rozmarynem.  ",
                "Włóż do nagrzanego piekarnika z termoobiegiem na 200°C, aż się zrumienią.",
            ],
            notes: "Otwieraj i zamykaj szybko drzwi piekarnika od czasu do czasu, aby wypuścić parę, która się gromadzi (ziemniaki muszą się wysuszyć jak najbardziej).",
        },
    },
};
